export interface ListRow {
  uid: string;
  /** Zero-based frame the annotation sits on. */
  frame: number;
  isAI: boolean;
  canonical: string;
  label: string;
  value: string;
  hidden: boolean;
}

/** Worksheet order; AI before manual for the same measurement; rows with no
 *  worksheet position last. */
export function orderRows(
  rows: ListRow[],
  worksheetIndex: Map<string, number>
): ListRow[] {
  const position = (r: ListRow) =>
    worksheetIndex.get(r.canonical) ?? Number.MAX_SAFE_INTEGER;
  return [...rows].sort(
    (a, b) =>
      position(a) - position(b) ||
      Number(b.isAI) - Number(a.isAI) ||
      a.frame - b.frame
  );
}
